import { Link } from "react-router-dom";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <div className="pt-40 pb-40 text-center px-5" data-testid="not-found-page">
      <Seo title="Page not found" />
      <p className="font-display text-7xl font-black text-arsenal">404</p>
      <h1 className="mt-4 font-display text-2xl font-bold">This canvas is blank.</h1>
      <p className="mt-2 text-slate-400">The page you're looking for doesn't exist.</p>
      <Link to="/" data-testid="not-found-home" className="clip-btn mt-8 inline-block bg-arsenal hover:bg-arsenal-bright text-white font-display font-bold tracking-widest text-sm px-8 py-3.5 transition-colors">
        BACK HOME
      </Link>
    </div>
  );
}
